import { makeStyles } from '@mui/styles';
import { Colors } from '../../layout/theme-next';
import { NextTheme } from '../../layout/theme-next/provider';

export default makeStyles<NextTheme>(theme => ({
  root: {
    width: 520,
  },
  contentWrapper: {
    width: '100%',
    paddingTop: theme.spacing(0.75),
  },
  content: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: theme.spacing(3, 3, 0),
    whiteSpace: 'pre-line',
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(1.5),
  },
  iconWrapper: {
    fontSize: 26,
    marginRight: theme.spacing(2),
  },
  iconError: {
    color: Colors.error,
  },
  iconWarning: {
    color: Colors.warning,
  },
}));
